import { Controller } from "@hotwired/stimulus"

// Radio buttons that show the block of the choice made: each `panel` names
// the values it belongs to in `data-choice-reveal-values` (space separated);
// the others are hidden. Their fields stay in the form, the server keeps only
// those of the choice. A panel must not carry a display class (flex, grid):
// it would override `hidden`.
//
// A select may be a choice too, inside a panel of a radio choice (the
// operator of a mobile account): its value counts only while its panel is
// shown, so the blocks of an operator never show under another family.
export default class extends Controller {
  static targets = ["choice", "panel"]

  connect() {
    this.sync()
  }

  sync() {
    const radios = this.choiceTargets.filter((input) => input.tagName !== "SELECT")
    const chosen = radios.filter((input) => input.checked).map((input) => input.value)
    this.reveal(chosen)
    const selects = this.choiceTargets.filter((input) => input.tagName === "SELECT" && !input.disabled)
    if (selects.length > 0) this.reveal(chosen.concat(selects.map((select) => select.value)))
  }

  reveal(chosen) {
    this.panelTargets.forEach((panel) => {
      const values = (panel.dataset.choiceRevealValues || "").split(" ")
      panel.hidden = !values.some((value) => chosen.includes(value))
      panel.querySelectorAll("input, select, textarea").forEach((field) => { field.disabled = panel.hidden })
    })
  }
}
